export default __webpack_public_path__ + "static/media/boxPumper2.d5554d19.png";